import React from 'react';
import { mod } from '~/client/helpers/add-bem-modifiers';
import type { Spinner as Props } from './spinner.types';
import { sizes, themes } from './spinner.types';

const Spinner: React.FunctionComponent<Props> & {
  sizes: typeof sizes;
  themes: typeof themes;
} = ({ size, theme }) => (
  <div className={mod('spinner', theme, size)}>
    <svg
      className="spinner__icon"
      width="48"
      height="48"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.1" cx="12" cy="12" r="10" />
      <path
        d="M12 2C13.9778 2 15.9112 2.58649 17.5557 3.6853C19.2002 4.78412 20.4819 6.3459 21.2388 8.17316C21.9957 10.0004 22.1937 12.0111 21.8079 13.9509C21.422 15.8907 20.4696 17.6725 19.0711 19.0711C17.6725 20.4696 15.8907 21.422 13.9509 21.8079C12.0111 22.1937 10.0004 21.9957 8.17317 21.2388C6.3459 20.4819 4.78412 19.2002 3.6853 17.5557C2.58649 15.9112 2 13.9778 2 12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);

Spinner.sizes = sizes;
Spinner.themes = themes;

export default Spinner;
